"use client";
import styled from "styled-components";
import { Col, Container, Row } from "react-bootstrap";
import { Img } from "@/components/Img";
import Title from "@/components/Title";
import stockBg from "@/public/images/static/stock-shadow.png";
import TitleSerial from "@/components/TitleSerial";
import Button from "@/components/Button";
import { hover } from "@/styles/globalStyleVars";
import reactHtmlParser from "react-html-parser";
import React from "react";

const Component = ({ data, sectionID }) => {

  return (
    <StyledComponent
      id={`${sectionID ? sectionID : ""}`}
      className="stock pt-200 pb-200"
    >
      <img className={"bg-img"} alt={"shadow"} src={data?.section_bg} />
      <Container>
        <p className={" bg-text-one parallax-xr"}>Our</p>
        <p className={" bg-text-two parallax-x"}>Story</p>
        <Row>
          <Col sm={12} className={'d-flex align-items-center justify-content-around'}>
            <TitleSerial line margin={"0 0 0 0 "} text={"I"}/>

            {data?.section_name && (
              <Title number={"I"} text={data?.section_name} />
            )}
          </Col>

          {/*<Col sm={{ span: 5, offset: 7 }}>*/}
          {/*  <TitleSerial margin={"50px 0 0 0 "} text={"I"} />*/}
          {/*</Col>*/}
        </Row>

        <Row className={"stock__content"}>
          <Col sm={{ span: 11, offset: 1 }}>
            {data?.title && (
              <h4 className={"fade-up"}>{reactHtmlParser(data?.title)}</h4>
            )}
          </Col>
        </Row>
        <Row className={"logo-desc"}>
          <Col sm={{ span: 3, offset: 1 }} className={"logo"}>
            {data?.logo && <img src={data?.logo} alt="ucb-logo" />}
            {data?.logo_stock && (
              <img src={data?.logo_stock} alt="ucb-stock-brokerage-logo" />
            )}
          </Col>
          <Col sm={8}>
            <p className={"fade-up"}>
              {data?.desc && reactHtmlParser(data?.desc)}
            </p>
          </Col>
        </Row>
      </Container>
    </StyledComponent>
  );
};

const StyledComponent = styled.div`
  overflow: hidden;
  position: relative;
  background-color: #f4f4f4;
  .bg-img {
    position: absolute;
    height: 100%;
    width: 100%;
    inset: 0;
    object-fit: cover;
    z-index: 2;
  }
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 0;
    left: 0;
    background: linear-gradient(
      to bottom,
      rgba(244, 244, 244, 0.1),
      /* Top (more black) */ rgba(244, 244, 244, 0.1),
      rgba(244, 244, 244, 0.1),
      /* Center (less black) */ rgba(244, 244, 244, 1),
      rgba(244, 244, 244, 1),
      rgba(244, 244, 244, 1) /* Bottom (more black) */
    );
    z-index: 3;
    opacity: 0.8;
  }
  .container {
    position: relative;
    z-index: 5;
  }

  h4 {
    margin-top: 90px;
    font-size: 24px;
    line-height: 32px;
    p {
    }
  }

  h6 {
    font-size: 24px;
    line-height: 32px;
    font-weight: 500;
  }

  .logo-desc {
    margin-top: 80px;
    .logo {
      display: flex;
      flex-direction: column;
      gap: 20px;
      img {
        max-width: 50%;
      }
    }
  }

  .bg-text-one,
  .bg-text-two {
    font-size: 200px;
    line-height: 250px;
    font-weight: 700;
    margin: 0;
    color: rgba(25, 25, 25, 0.05);
    text-transform: uppercase;
    position: absolute;
    white-space: nowrap;
    font-family: "Aeonik", Euclid Square, Arial, Helvetica, freesans, sans-serif;

    @media (max-width: 767px) {
      font-size: 120px;
      line-height: 120px;
    }
  }
  .bg-text-one {
    left: 0;
    bottom: 300px;
  }

  .bg-text-two {
    right: 0;
    bottom: -50px;
  }

  @media (max-width: 768px) {
    .title {
      &:after {
        height: 304px;
        bottom: -80px;
      }
    }
    h2 {
      font-weight: 600;
    }
    .col-sm-4,
    .col-sm-5 {
      min-width: 100%;
      margin: 0;
    }

    .stock__content {
      flex-direction: column-reverse;
      margin-top: 20px;
    }

    .logo-desc {
      margin-top: 40px;

      .logo {
        margin-bottom: 40px;
      }
    }

    h4 {
      margin-top: 70px;
    }
  }
`;
export default Component;
